<template>
  <div>
    <img-dialog-header
      :image-url="page.active_image ? page.active_image.url : ''"
    >
      <div class="content prose" v-html="page.template.introductie"/>
    </img-dialog-header>

    <wave-content>
      <div class="content prose" v-html="page.template.tekst"/>
    </wave-content>

    <mentor-quickview
      header-txt="Zoek de begeleider die bij jou past"
    />
  </div>
</template>

<script>
import ImgDialogHeader from '~/components/headers/ImgDialogHeader';
import WaveContent from '~/components/fullwidth-blocks/WaveContent';
import MentorQuickview from '~/components/begeleiders/MentorQuickview';
import page from '~/plugins/mixins/page';

export default {
  components: {MentorQuickview, WaveContent, ImgDialogHeader},
  mixins: [page],
};
</script>
